export default __webpack_public_path__ + "static/media/person.66858847.svg";